import { prefixObjectValues } from '../utils';

const feedback = {
  trigger: 'trigger',
};

export default prefixObjectValues(feedback, 'feedback');
